import styled from 'styled-components'

import { useSafetyReportJobs } from '../../contexts/safetyReportJobsContext'
import { useUserContext } from '../../contexts/userContext'

const Banner = styled.span`
  font-size: 13px;
  color: #5c6f8a;
  max-width: 360px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export function SafetyReportJobBanner() {
  const { pendingJobs, jobStatusById } = useSafetyReportJobs()
  const { state } = useUserContext()
  if (state.user_type !== 'super' || pendingJobs.length === 0) {
    return null
  }
  const text =
    pendingJobs.length === 1
      ? (() => {
          const job = pendingJobs[0]
          const st = jobStatusById[job.jobId]
          if (st === 'pending') {
            return `Safety report queued (${job.projectName})…`
          }
          if (st === 'running') {
            return `Safety report generating on the server (${job.projectName})…`
          }
          return `Safety report in progress (${job.projectName})…`
        })()
      : `${pendingJobs.length} safety reports in progress…`
  return (
    <Banner title={text} role="status" aria-live="polite">
      {text}
    </Banner>
  )
}
